import type { IconPropsWithoutName } from '../index'

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const TriangleAlertFilled: React.FC<IconPropsWithoutName> = ({
  color = 'currentColor',
  className,
  ...props
}) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon; the Icon wrapper carries the accessible name
    <svg viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M8.57727 0.500439L14.9281 11.5005C15.1123 11.8193 15.003 12.2271 14.6841 12.4111C14.5828 12.4697 14.4678 12.5005 14.3508 12.5005H1.64909C1.2809 12.5005 0.982422 12.202 0.982422 11.8338C0.982422 11.7167 1.01323 11.6018 1.07174 11.5005L7.4226 0.500439C7.60667 0.181573 8.0144 0.0723262 8.33327 0.256419C8.4346 0.314933 8.5188 0.399093 8.57727 0.500439ZM7.33327 9.16713V10.5005H8.6666V9.16713H7.33327ZM7.33327 4.50044V7.83379H8.6666V4.50044H7.33327Z"
        fill={color}
      />
    </svg>
  )
}
